import React, { ReactNode } from "react";
import "./App.css";
import store from "./redux/Store";
import { Provider } from "react-redux";
import Wrapper from "./pages/Wrapper";
import Navigation from "./Navigator";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  MsalProvider,
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utils/AzureAuthService";
import LoginPage from "./pages/LoginPage";
import { useEffect } from "react";

const msalInstance = new PublicClientApplication(msalConfig);

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = sessionStorage.getItem("access_token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

const AuthWrapper: React.FC = () => {
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (accounts?.length > 0 && location?.pathname === "/") {
      navigate("/home");
    }
  }, [accounts, location, navigate]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UnauthenticatedTemplate>
            <LoginPage />
          </UnauthenticatedTemplate>
        }
      />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Provider store={store}>
              <Wrapper>
                <Navigation />
              </Wrapper>
            </Provider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <AuthWrapper />
      </Router>
    </MsalProvider>
  );
};

export default App;
